<template>
  <div class="card shadow-sm text-dark text-start" ref="capture">
    <div class="card-header fs-6 fw-bold">Summary</div>
    <div class="card-body p-2">
      <div>
        <div class="alert alert-primary">
          Below are your results for the survey. To learn more about the topics
          shown in this survey you can click to view more resources. You can now
          export the table results of your survey to upload into Canvas.
          <span class="fw-bold"
            >Your results will not be saved when you leave this page.</span
          >
        </div>
        <div v-if="showFullnameForm">
          <input
            :class="{ 'border-2 border-danger': !fullName?.length > 0 }"
            type="text"
            aria-label="Name for survey export "
            class="form-control shadow-sm w-50"
            placeholder="Enter your name to export your results"
            v-model="fullName"
          />
        </div>
      </div>
      <div v-if="getSurveyAnswers.length > 0" ref="summary">
        <table class="table table-striped">
          <thead>
            <tr>
              <th id="user identification">
                <span v-if="!showFullnameForm">
                  Results for
                  {{ getFullname }}</span
                >
                <span v-else>
                  {{ fullName }}
                </span>
              </th>
            </tr>
            <tr>
              <th scope="col">Section</th>
              <th scope="col">Advanced</th>
              <th scope="col">Good</th>
              <th scope="col">Fair</th>
              <th scope="col">Limited</th>
              <th scope="col">No Response</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="topic in questionTopics" :key="topic">
              <th scope="row">{{ topic }}</th>
              <td>{{ getAnswerCount(topic, "ADVANCED") }}</td>
              <td>{{ getAnswerCount(topic, "GOOD") }}</td>
              <td>{{ getAnswerCount(topic, "FAIR") }}</td>
              <td>{{ getAnswerCount(topic, "LIMITED") }}</td>
              <td>{{ getAnswerCount(topic, "NO_RESPONSE") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No Responses Recorded</div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div>
          <button class="btn btn-secondary">
            <RouterLink :to="{ name: 'Resources' }" class="nav-link me-3"
              >Find Resources</RouterLink
            >
          </button>
        </div>
        <div
          v-if="getSurveyAnswers?.length === getQuestionData?.length"
          class="fw-bold"
        >
          All questions answered
        </div>
        <button
          class="btn btn-success"
          @click="exportResults"
          :disabled="!fullName?.length > 0 && showFullnameForm"
        >
          Export Results
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ANSWER from "@/data/Answers.js";
import html2canvas from "html2canvas";
import EventAPI from "@/helpers/EventAPI";

export default {
  name: "SurveySummary",
  components: {},
  mixins: [EventAPI],
  data() {
    return { ANSWER, fullName: null };
  },
  computed: {
    ...mapGetters(["getSurveyAnswers", "getQuestionData", "getFullname"]),
    showFullnameForm() {
      return !this.getFullname?.length > 0;
    },
    questionTopics() {
      const topics = new Set();
      this.getSurveyAnswers.forEach((answer) => {
        topics.add(answer.topic);
      });
      return Array.from(topics);
    }
  },
  mounted() {
    let payload = {
      event_name: "Completed"
    };
    this.createContentEntry(payload);
  },
  methods: {
    getAnswerCount(topic, answerType) {
      return this.getSurveyAnswers.filter(
        (answer) => answer.topic === topic && answer.answer === answerType
      ).length;
    },
    exportResults() {
      console.log("export results");
      this.loadingImage = true;
      let ref = this.$refs.summary;

      new html2canvas(ref, {
        backgroundColor: "white",
        scrollX: 0,
        scrollY: -window.scrollY,
        scale: 1,
        allowTaint: true,
        useCORS: true,
        imageTimeout: 5000
      }).then(function (canvas) {
        let uri = canvas.toDataURL();
        let filename = "survey-summary";
        let link = document.createElement("a");
        if (typeof link.download === "string") {
          link.href = uri;
          link.download = filename;
          //Firefox requires the link to be in the body
          document.body.appendChild(link);

          setTimeout(() => {
            //simulate click
            link.click();
            //remove the link when done
            document.body.removeChild(link);

            ref.loadingImage = false;
          }, 5000);
        } else {
          window.open(uri);
        }
      });
    }
  }
};
</script>

<style scoped></style>
